module.exports = __webpack_public_path__ + "static/media/how_1xhdpi.4a6da808.png";